import * as Yup from "yup";

import { firstNameSchema, lastNameSchema, ninSchema } from "Validation/index";

import { NoLoginFormValues } from "./loginFormValues";

export const validationSchema =
  () => (): Yup.ObjectSchema<NoLoginFormValues> => {
    return Yup.object({
      firstName: firstNameSchema(),
      lastName: lastNameSchema(),
      nin: ninSchema(),
    }).defined();
  };
